import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LocationSelector } from './models/location-selector/location-selector-model';
import { LocationSelectorInfo } from './models/locationSelectorModel';

@Component({
  selector: 'angular-location-selector',
  templateUrl: 'angular-location-selector.component.html',
  styles: []
})
export class AngularLocationSelectorComponent implements OnInit {
  @Input() type: string = "single";
  @Input() labelText: string;
  @Input() selectedLocationId: number = null;
  @Input() selectedLocationName: string = 'Select';
  @Input() public selectorDisabledLocation: boolean = false;
  @Input() public locationHierachy: LocationSelector
  @Input() hoverText: string;
  @Output() public onChange : EventEmitter<any> = new EventEmitter<any>();


  constructor() { }

  ngOnInit(): void {
  }

  onLocationsFetched(locations: LocationSelector) {
    this.locationHierachy = locations;
  }

  public updateLocationState(dataItem:LocationSelectorInfo){
    this.onChange.emit(dataItem);
  }

}
